export const USER_TRACKER_STATUSES = {
  NO_TRACKERS: 'NO_TRACKERS',
  NO_COMPATIBLE_TRACKERS: 'NO_COMPATIBLE_TRACKERS',
  BROKEN_TRACKER: 'BROKEN_TRACKER',
  NO_DATA: 'NO_DATA',
  SYNCING: 'SYNCING',
}
